import { getApiClient } from '../../utils'
import { UploadImageRequest, UploadImageResponse } from './upload-image.types'

export const uploadImageApi = {
  uploadImage: (requestBody: UploadImageRequest, locale: string) =>
    getApiClient(locale)
      .post<{ data: UploadImageResponse }>('v1/files/image', requestBody)
      .then(({ data }) => data.data),

  uploadImages: (requestBody: UploadImageRequest, locale: string) =>
    getApiClient(locale)
      .post<{ data: UploadImageResponse[] }>('v1/files/images', requestBody)
      .then(({ data }) => data.data)
}
